import { SupportTicket, SupportTicketStatus, SupportTicketType } from "@/types";
import { deleteData, getData, postData, putData } from "./axios-service";

function supportTicketMapper(inputSupportTicket: any): SupportTicket {
  return {
    id: inputSupportTicket.id,
    title: inputSupportTicket.title,
    laverieId: inputSupportTicket.laverieId,
    ticketType: inputSupportTicket.ticketType,
    productId: inputSupportTicket.productId,
    productType: inputSupportTicket.productType,
    description: inputSupportTicket.description,
    errorCode: inputSupportTicket.errorCode,
    centralErrorCode: inputSupportTicket.centralErrorCode,
    paymentMethod: inputSupportTicket.paymentMethod,
    callerType: inputSupportTicket.callerType,
    contactType: inputSupportTicket.contactType,
    caller: inputSupportTicket.caller,
    telephone: inputSupportTicket.telephone,
    email: inputSupportTicket.email,
    concernedService: inputSupportTicket.concernedService,
    waterStatus: inputSupportTicket.waterStatus,
    tapsStatus: inputSupportTicket.tapsStatus,
    residenceName: inputSupportTicket.residenceName,
    buildingNumber: inputSupportTicket.buildingNumber,
    city: inputSupportTicket.city,
    postalCode: inputSupportTicket.postalCode,
    roomOrApartmentNumber: inputSupportTicket.roomOrApartmentNumber,
    paymentCardLast4Digits: inputSupportTicket.paymentCardLast4Digits,
    paymentDate: inputSupportTicket.paymentDate,
    paymentTime: inputSupportTicket.paymentTime,
    productIsPluggedIn: inputSupportTicket.productIsPluggedIn,
    drumTurns: inputSupportTicket.drumTurns,
    coinSlotTakesCoins: inputSupportTicket.coinSlotTakesCoins,
    clientCompany: inputSupportTicket.clientCompany,
    ticketStatus: inputSupportTicket.ticketStatus,
    assigneeId: inputSupportTicket.assigneeId,
    assigneeFullName: inputSupportTicket.assigneeFullName,
    creatorId: inputSupportTicket.creatorId,
    creationDate: inputSupportTicket.creationDate,
    modificationDate: inputSupportTicket.modificationDate,
    creationTime: inputSupportTicket.creationTime,
    modificationTime: inputSupportTicket.modificationTime
  };
}

export function supportTicketMapperArray(inputArray: any[]): SupportTicket[] {
  return inputArray.map(supportTicketMapper);
}

export async function fetchSupportTickets(ticketTypes?: SupportTicketType[], ticketStatuses?: SupportTicketStatus[], productId?: string): Promise<SupportTicket[]> {
  const params = new URLSearchParams();

  if (ticketTypes?.length) {
    ticketTypes.forEach((ticketType) => params.append("ticketTypes", ticketType));
  }

  if (ticketStatuses?.length) {
    ticketStatuses.forEach((ticketStatus) => params.append("ticketStatuses", ticketStatus));
  }

  if (productId) {
    params.append("productId", productId);
  }

  const queryString = params.toString();
  const url = queryString ? `/support-tickets?${queryString}` : "/support-tickets";

  const tickets = await getData<SupportTicket[]>(url);
  return supportTicketMapperArray(tickets ?? []);
}

export async function fetchSupportTicketById(id: string): Promise<SupportTicket> {
  const ticket = await getData<SupportTicket>(`/support-tickets/${id}`);
  return supportTicketMapper(ticket);
}

export async function postSupportTicket(ticket: Partial<SupportTicket>): Promise<SupportTicket> {
  const response = await postData("/support-tickets", ticket);
  return supportTicketMapper(response);
}

export function putSupportTicket(id: string, ticket: Partial<SupportTicket>): Promise<any> {
  return putData(`/support-tickets/${id}`, ticket);
}

export function deleteSupportTicket(id: string): Promise<any> {
  return deleteData(`/support-tickets/${id}`);
}